module.exports = __webpack_public_path__ + "static/media/298210.e7edaec2.png";